<app-coming-soon title="Tasks Report" icon="task"></app-coming-soon>
